/*!
 * SPDX-FileCopyrightText: 2025 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: GPL-3.0-or-later
 */
import isSvg from 'is-svg';
/**
 * Register a new sidebar action
 *
 * @param action - The action to register
 */
export function registerSidebarAction(action) {
    if (!action.id) {
        throw new Error('Sidebar actions must have an id');
    }
    if (!action.element || !action.element.startsWith('oca_') || !window.customElements.get(action.element)) {
        throw new Error('Sidebar actions must provide a registered custom web component identifier');
    }
    if (typeof action.order !== 'number') {
        throw new Error('Sidebar actions must have the order property');
    }
    if (typeof action.enabled !== 'function') {
        throw new Error('Sidebar actions must implement the "enabled" method');
    }
    window._nc_files_sharing_sidebar_actions ??= new Map();
    if (window._nc_files_sharing_sidebar_actions.has(action.id)) {
        throw new Error(`Sidebar action with id "${action.id}" is already registered`);
    }
    window._nc_files_sharing_sidebar_actions.set(action.id, action);
}
/**
 * Register a new sidebar action
 *
 * @param action - The action to register
 */
export function registerSidebarInlineAction(action) {
    if (!action.id) {
        throw new Error('Sidebar actions must have an id');
    }
    if (typeof action.order !== 'number') {
        throw new Error('Sidebar actions must have the "order" property');
    }
    if (typeof action.iconSvg !== 'string' || !isSvg(action.iconSvg)) {
        throw new Error('Sidebar actions must have the "iconSvg" property');
    }
    if (typeof action.label !== 'function') {
        throw new Error('Sidebar actions must implement the "label" method');
    }
    if (typeof action.exec !== 'function') {
        throw new Error('Sidebar actions must implement the "exec" method');
    }
    if (typeof action.enabled !== 'function') {
        throw new Error('Sidebar actions must implement the "enabled" method');
    }
    window._nc_files_sharing_sidebar_inline_actions ??= new Map();
    if (window._nc_files_sharing_sidebar_inline_actions.has(action.id)) {
        throw new Error(`Sidebar action with id "${action.id}" is already registered`);
    }
    window._nc_files_sharing_sidebar_inline_actions.set(action.id, action);
}
/**
 * Get all registered sidebar actions
 */
export function getSidebarActions() {
    return [...(window._nc_files_sharing_sidebar_actions?.values() ?? [])];
}
/**
 * Get all registered sidebar inline actions
 */
export function getSidebarInlineActions() {
    return [...(window._nc_files_sharing_sidebar_inline_actions?.values() ?? [])];
}
